import { IViewConfiguration } from '@ispm/therapies/interfaces/view-configuration.interface';

/**
 * this configuration was created for support cases lower than version 3.0.0
 * @type {IViewConfiguration}
 */
export const DEFAULT_THERAPY_EDITING_CONFIGURATION = {
    'title': 'Edit therapies for $(gene.name) $(alteration)',
    'buttons': {
      'approve': 'Save',
      'decline': 'Cancel'
    },
  'forms': [
    {
      'formId': 'THERAPY-MATCH-INFO-EDITABLE'
    },
    {
      'path': 'drugs',
      'type': 'array',
      'title': 'Drugs',
      'formId': 'THERAPY-DRUG'
    },
    {
      'path': 'guidlines',
      'type': 'array',
      'title': 'Guidelines',
      'formId': 'THERAPY-GUIDELINE'
    },
    {
      'path': 'incidence',
      'type': 'array',
      'title': 'Incidence in disease',
      'formId': 'THERAPY-SUMMARY'
    },
    {
      'path': 'clinicalRelevance',
      'type': 'array',
      'title': 'Clinical relevance',
      'formId': 'THERAPY-SUMMARY'
    },
    {
      'path': 'diseaseSummary',
      'type': 'array',
      'title': 'Clinical information',
      'formId': 'THERAPY-SUMMARY'
    },
    {
      'path': 'gene.references.reference',
      'type': 'array',
      'title': 'Gene (references)',
      'formId': 'REFERENCE-INFO-EDITABLE'
    },
    {
      'path': 'effectReferences.reference',
      'type': 'array',
      'title': 'Molecular function (references)',
      'formId': 'REFERENCE-INFO-EDITABLE'
    },
    {
      'path': 'drugResistanceReferences.reference',
      'type': 'array',
      'title': 'Drug resistance (references)',
      'formId': 'REFERENCE-INFO-EDITABLE'
    },
    {
      'path': 'treatmentApproachReferences.reference',
      'type': 'array',
      'title': 'Drug sensitivity (references)',
      'formId': 'REFERENCE-INFO-EDITABLE'
    },
    {
      'path': 'theraputicRelevanceDetailsReferences.reference',
      'type': 'array',
      'title': 'Clinical relevance (references)',
      'formId': 'REFERENCE-INFO-EDITABLE'
    }
  ]
};
